import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { addDays } from 'date-fns';
import { localDate, parseIso8601Date } from 'helpers/time';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { Heading } from 'components/Heading/Heading';
import { Section } from 'components/Section/Section';
import { RESULT_TYPES } from './Search.constants';
import { messages } from './Search.messages';

export class SearchNoResults extends PureComponent {
  handleOnSelectNextDate = () => {
    const { onSelectDate, selectedDate } = this.props;

    if (selectedDate) {
      const nextDate = addDays(parseIso8601Date(selectedDate), 1);
      onSelectDate(localDate(nextDate));
    }
  };

  render() {
    const {
      className,
      clearScheduleFiltersAndSearch,
      clearVenueFiltersAndSearch,
      isNextDaySelectable,
      resultType,
    } = this.props;

    return (
      <Section className={cx(className)}>
        <Heading className="gamma">
          <LocalizableMessage message={messages.header} />
        </Heading>
        {resultType === RESULT_TYPES.VENUE ? (
          <span>
            <LocalizableMessage tagName="p" message={messages.venueCtaPrompt} />
            <div>
              <button onClick={clearVenueFiltersAndSearch} className="bt bt--primary">
                <LocalizableMessage message={messages.clearVenueFilters} />
              </button>
            </div>
          </span>
        ) : (
          <span>
            <LocalizableMessage tagName="p" message={messages.scheduleCtaPrompt} />
            <div>
              <button onClick={clearScheduleFiltersAndSearch} className="bt bt--primary">
                <LocalizableMessage message={messages.clearScheduleFilters} />
              </button>
              <button
                className={cx('bt', {
                  disabled: !isNextDaySelectable,
                })}
                disabled={!isNextDaySelectable}
                onClick={this.handleOnSelectNextDate}>
                <LocalizableMessage message={messages.nextDay} />
              </button>
            </div>
          </span>
        )}
      </Section>
    );
  }
}

SearchNoResults.propTypes = {
  className: PropTypes.string,
  clearScheduleFiltersAndSearch: PropTypes.func.isRequired,
  clearVenueFiltersAndSearch: PropTypes.func.isRequired,
  isNextDaySelectable: PropTypes.bool.isRequired,
  onSelectDate: PropTypes.func.isRequired,
  resultType: PropTypes.oneOf(Object.values(RESULT_TYPES)),
  selectedDate: PropTypes.string,
};
